// extracted by mini-css-extract-plugin
export default {"container":"Social_container__W9Flx","box":"Social_box__SkdQk"};